import * as DialogPrimitive from '@radix-ui/react-dialog';
import * as React from 'react';
import { cn } from '@/lib/cn';

/**
 * Lightweight drawer built on Radix Dialog. Slides in from the left on mobile.
 * Used for the app's mobile navigation drawer; behaves as a focus-trapped,
 * Esc/backdrop-dismissable Dialog so we don't add a new component library.
 */
export const Sheet = DialogPrimitive.Root;
export const SheetTrigger = DialogPrimitive.Trigger;
export const SheetClose = DialogPrimitive.Close;
export const SheetTitle = DialogPrimitive.Title;
export const SheetDescription = DialogPrimitive.Description;

export const SheetContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content> & {
    side?: 'left' | 'right';
  }
>(({ className, children, side = 'left', ...props }, ref) => (
  <DialogPrimitive.Portal>
    <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-foreground/40 data-[state=open]:animate-in data-[state=closed]:animate-out" />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        'fixed top-0 bottom-0 z-50 flex w-[min(85vw,280px)] flex-col bg-sidebar text-sidebar-foreground shadow-xl focus:outline-none',
        side === 'left'
          ? 'left-0 border-r border-sidebar-border'
          : 'right-0 border-l border-sidebar-border',
        className,
      )}
      {...props}
    >
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));
SheetContent.displayName = 'SheetContent';
